<div class="planillasPdf container my-5">
  <div class="row align-items-center4">
    <h2 class="text-left h3-tipografia-govco mb-0">
      {{ 'edicion-documento-adjunto.titulo' | translate }}
    </h2>
    <p>{{ 'edicion-documento-adjunto.seleccione-plantilla' | translate }}</p>
  </div>

  <select [(ngModel)]="plantillaId" (change)="selectPlantilla()">
    <option *ngFor="let template of listaPlantillas" [value]="template.Id_Plantilla_PDF">
      {{ template.Titulo_Plantilla }}
    </option>
  </select>

  <div class="d-flex justify-content-end">
    <button
      type="submit"
      class="btn-govco fill-btn-govco btn-form"
      style="width: 180px; height: 42px; margin-top: 16px"
      (click)="guardarPlantilla()"
      aria-label="Guardar plantilla">
      {{ 'edicion-documento-adjunto.guardar' | translate }}
    </button>
  </div>

  <div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="document-preview h-100">

          <div class="header">
            <img [src]="plantilla?.Url_Logo1" class="logo left" *ngIf="plantilla?.Url_Logo1" alt=""/>
            <img [src]="plantilla?.Url_Logo2" class="logo right" *ngIf="plantilla?.Url_Logo2" alt=""/>
          </div>

          <div [innerHTML]="plantillaHtml" class="document-body"></div>
        </div>
      </div>
      <div class="col-12 col-md-6 box-editing">
        <div class="row document-editing h-100" [formGroup]="form">
          <div class="d-flex flex-column align-items-center col-12 col-md-6 gap-1">
            <img [src]="imageSrcLogo1 || ''" alt="Logo"
                 style="height: 80px; ">
            <div class="d-flex flex-column gap-2">
              <button
                class="btn-govco fill-btn-govco" 
                (click)="openFilePickerLogo1()"
                aria-label="Cargue nuevo logo">
                <i aria-hidden="true" class="fa fa-cloud-upload nav-icon"></i>&nbsp;
                {{ 'edicion-documento-adjunto.cargue-nuevo-logo' | translate }}
              </button>
              <input #fileInputLogo1 type="file" style="display: none" (change)="onFileSelectedLogo1($event)">


            </div>
          </div>

          <div class="d-flex flex-column align-items-center col-12 col-md-6 gap-1">
            <img [src]="imageSrcLogo2 || ''" alt="Logo"
                 style="height: 80px">
            <div class="d-flex flex-column gap-2">
              <button
                class="btn-govco fill-btn-govco" (click)="openFilePickerLogo2()"
                aria-label="Cargue nuevo logo">
                <i aria-hidden="true" class="fa fa-cloud-upload nav-icon"></i>&nbsp;
                {{ 'edicion-documento-adjunto.cargue-nuevo-logo' | translate }}
              </button>
              <input #fileInputLogo2 type="file" style="display: none" (change)="onFileSelectedLogo2($event)">
            </div>
          </div>

          <div class="col-12 p-md-2">
            <label for="encabezadoPlantilla" class="form-label text3-tipografia-govco mb-md-0 me-md-3 w-100 w-md-25">
              {{ "edicion-documento-adjunto.encabezado-plantilla"| translate }}
            </label>
            <input
              type="text"
              class="form-control flex-grow-1"
              id="encabezadoPlantilla"
              formControlName="encabezadoPlantilla"
              placeholder="{{'edicion-documento-adjunto.encabezado-plantilla' | translate}}"
              [ngClass]="{
              'is-valid': form.get('encabezadoPlantilla')?.valid && form.get('encabezadoPlantilla')?.touched,
              'is-invalid': form.get('encabezadoPlantilla')?.invalid && form.get('encabezadoPlantilla')?.touched
            }"/>
            <div *ngIf="form.get('encabezadoPlantilla')?.errors?.['required']" class="invalid-feedback">
              {{ 'edicion-documento-adjunto.encabezado-plantilla-requerido' | translate }}
            </div>
          </div>

          <div class="col-12 p-md-2">
            <label for="variables" class="form-label text3-tipografia-govco mb-md-0 me-md-3 w-100 w-md-25">
              {{ "edicion-documento-adjunto.variables"| translate }}
            </label>
            <input
              type="text"
              class="form-control flex-grow-1"
              id="variables"
              formControlName="variables"
              readonly="true"
              placeholder="{{'edicion-documento-adjunto.variables' | translate}}"
              [ngClass]="{
              'is-valid': form.get('variables')?.valid && form.get('variables')?.touched,
              'is-invalid': form.get('variables')?.invalid && form.get('variables')?.touched
            }"/>
            <div *ngIf="form.get('encabezadoPlantilla')?.errors?.['required']" class="invalid-feedback">
              {{ 'edicion-documento-adjunto.variables-requerido' | translate }}
            </div>
          </div>

          <div class="col-12 p-md-2" style="height: 250px">
            <!--<label for="variables"
                   class="form-label text3-tipografia-govco mb-md-0 me-md-3 w-100 w-md-25">
              {{ "edicion-documento-adjunto.cuerpo-plantilla"| translate }}
            </label>
            <div #editorContainer class="jodit-container"></div>-->
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
